var React = require('react');

function CheckmarkInline (props) {
    return React.createElement("g",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"2"},React.createElement("path",{"d":"M5,13.6363636 C8.58974359,16.5454545 10.3846154,18 10.3846154,18 C10.3846154,18 13.2564103,14 19,6"})));
}

CheckmarkInline.defaultProps = {"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = CheckmarkInline;

CheckmarkInline.default = CheckmarkInline;
